import type { Custodian } from 'models/custodian';
import { secondaryMarketDealSplitRowAdded as secondaryMarketRtFormDealSplitRowAdded } from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm';
import {
  getSecondaryMarketRtFormClient,
  getSecondaryMarketRtFormDealSplitRows,
} from 'state/secondaryMarket/realtimeQuote/realtimeQuoteForm/realTimeQuoteForm.selectors';
import { fromSecondaryMarket } from 'state/selectors';
import type { Thunk } from 'state/state.common';
import { getTabType } from 'state/workspaces/tabs/tabs.selector';

import {
  secondaryMarketAstroClientRequested,
  secondaryMarketReferentialAstroClientFetched,
} from './astroClient.actions';
import { findDefaultCustodianId } from './astroClient.utils';

export function secondaryMarketReferentialAstroClientRetryLoadingThunk(tabId: string): Thunk<void> {
  return (dispatch, getState) => {
    const state = getState();
    const client = getSecondaryMarketRtFormClient(state, tabId);
    if (client?.id !== undefined) {
      dispatch(secondaryMarketAstroClientRequested(tabId, client.id));
    }
  };
}

export function secondaryMarketReferentialAstroClientFetchedThunk(
  tabId: string,
  id: string,
  custodians: Custodian[],
): Thunk<void> {
  const custodiansCount = custodians.length;
  return (dispatch, getState) => {
    const state = getState();
    const dealSplitRows = getSecondaryMarketRtFormDealSplitRows(state, tabId);
    dispatch(secondaryMarketReferentialAstroClientFetched(id, custodians));
    const tabType = getTabType(state, tabId);

    if (tabType === 'realtimeQuote') {
      const defaultCustodianId = findDefaultCustodianId(custodians, id);
      const remainingNotional = Math.max(
        0,
        fromSecondaryMarket.realtimeQuote.form.getSecondaryMarketRtFormTotalUnallocatedNotional(state, tabId) ?? 0,
      );

      if (custodiansCount > 0 && dealSplitRows.length === 0) {
        dispatch(
          secondaryMarketRtFormDealSplitRowAdded(
            tabId,
            defaultCustodianId,
            custodiansCount === 1 ? remainingNotional : undefined,
          ),
        );
      }
    }
  };
}
